import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { OpcionalApiService } from 'src/app/dao/api_opcionais.service';
import { Opcional } from 'src/app/model/opcional';

@Component({
  selector: 'app-opcionais-form',
  templateUrl: './opcionais-form.page.html',
  styleUrls: ['./opcionais-form.page.scss'],
})
export class OpcionaisFormPage implements OnInit {

  title = 'Novo adicional';
  opcional: Opcional;

  constructor(private route: ActivatedRoute, private toast: ToastService, private apiOpcionais: OpcionalApiService) { }

  ngOnInit() {
    this.opcional = new Opcional();

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.title = 'Editar adicional';
      // tslint:disable-next-line: radix
      this.loadCategory(parseInt(idParam));
    }
  }

  async loadCategory(id: number) {
    this.opcional = await this.apiOpcionais.getById(id);
  }

  async onSubmit() {
    try {
      const result = await this.apiOpcionais.save(this.opcional);
      this.opcional.id = result.id;
      this.toast.showSucess('Adicional salvo com sucesso');
    } catch (error) {
      console.log(error);
      this.toast.showError('Ocorreu um erro ao tentar salvar o Adicional');
    }

  }

}
